import angular from 'angular';

module.exports = angular.module('common.directives.min-max', [])
.directive('odMin', function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      var min = attrs.odMin;

      ngModel.$parsers.push(function(value) {
        if (!value) return null;

        var floatValue = parseFloat(value, 10);
        ngModel.$setValidity('min', floatValue >= min);

        return value;
      });
    }
  };
})
.directive('odMax', function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      var max = attrs.odMax;

      ngModel.$parsers.push(function(value) {
        if (!value) return null;

        var floatValue = parseFloat(value, 10);
        ngModel.$setValidity('max', floatValue <= max);

        return value;
      });
    }
  };
})
.name;




/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/min-max.js
 **/